import axiosNew from '../../../helpers/axios'
import { cleanQueryParams } from '../../../helpers/queryBuilder'

// LIST JOB APPLICATIONS STATUS
export const apiGetStatusWiseCount = (params) => {
    return new Promise(async (resolve) => {
        let query = cleanQueryParams(params)

        try {
            const jobs = await axiosNew({
                url: `candidate-application/job/count`,
                method: 'get',
                params: query,
            })
            resolve({
                data: jobs?.data ?? [],
            })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// LIST USERS
export const apiJobApplicantListByStatus = (payload) => {
    const { search = '', skip = 0, limit = 10, filter = {} } = payload
    return new Promise(async (resolve) => {
        try {
            let data = {
                skip,
                jobId: filter?.job,
                status: filter?.status,
                limit,
                search: filter?.search,
                //     select: [
                //         'name',
                //         'email',
                //         'employeeNumber',
                //         'phone',
                //         'countryCode',
                //         'flag',
                //         'address',
                //         'employmentType',
                //         'state',
                //         'department',
                //         'designation',
                //         'emergencyName',
                //         'emergencyPhone',
                //         'notes',
                //         'role',
                //         'isActive',
                //         'profilePicture',
                //         'isOurUser',
                //         'isAssigned',
                //         'isWorkspaceAssigned',
                //         'isTalentUser',
                //         'price',
                //         'dailyWorkingHours',
                //         'weeklyWorkingDays',
                //         'status',
                //         'timeZone',
                //         'job',
                //         'location',
                //         'resume',
                //     ],
                //     populate: {
                //         name: [
                //             {
                //                 path: 'role',
                //                 select: 'roleName',
                //             },
                //             {
                //                 path: 'workspace',
                //                 select: 'domain logo companyName',
                //             },
                //             {
                //                 path: 'designation',
                //                 select: 'name',
                //             },
                //         ],
                //     },
            }

            let query = cleanQueryParams(data)

            if (search?.length > 0) {
                data['search'] = {
                    name: search,
                    email: search,
                    phone: search,
                }
            }
            const users = await axiosNew({
                url: 'candidate-application/candidate/list',
                method: 'get',
                params: query,
            })
            resolve({
                data: users?.data && users?.data ? users?.data : [],
                isNext: users?.data?.isNext,
            })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// UPDATE JOB APPLICATION STATUS
export const apiUpdateJobApplicationStatus = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const update = await axiosNew({
                url: '/candidate-application/candidate/status',
                data: payload,
                method: 'PUT',
            })
            resolve({ data: update?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// ADD JOB APPLICATION NOTE
export const apiAddJobApplicationNote = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const update = await axiosNew({
                url: 'job-applicant/note/create',
                data: payload,
                method: 'post',
            })
            resolve({ data: update?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET JOB APPLICATION NOTES
export const apiGetJobApplicationNotes = async (params) => {
    return new Promise(async (resolve) => {
        try {
            const notes = await axiosNew({
                url: 'job-applicant/note/list',
                method: 'get',
                params,
            })
            resolve({ data: notes?.data ?? [] })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

export const getCandidateById = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: `candidate/${id}`,
                method: 'GET',
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
